export default __webpack_public_path__ + "static/media/eUTXOModels.679cf88a.png";